// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/account/v1/activation.proto (package kitecorp.transferify.account.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/account/v1/activation.proto.
 */
export const file_kitecorp_transferify_account_v1_activation: GenFile = /*@__PURE__*/
  fileDesc("CjBraXRlY29ycC90cmFuc2ZlcmlmeS9hY2NvdW50L3YxL2FjdGl2YXRpb24ucHJvdG8SH2tpdGVjb3JwLnRyYW5zZmVyaWZ5LmFjY291bnQudjEiMQoWQWN0aXZhdGVBY2NvdW50UmVxdWVzdBIXCgpsaW5rX3Rva2VuGAEgASgJQgOAAQEibAoXQWN0aXZhdGVBY2NvdW50UmVzcG9uc2USFgoJZnVsbF9uYW1lGAEgASgJQgOAAQESEgoFZW1haWwYAiABKAlCA4ABARIZCgdjb21wYW55GAMgASgJQgOAAQFIAIgBAUIKCghfY29tcGFueSIeChxSZXNlbmRBY3RpdmF0aW9uRW1haWxSZXF1ZXN0MqACChFBY3RpdmF0aW9uU2VydmljZRKPAQoPQWN0aXZhdGVBY2NvdW50Ejcua2l0ZWNvcnAudHJhbnNmZXJpZnkuYWNjb3VudC52MS5BY3RpdmF0ZUFjY291bnRSZXF1ZXN0Gjgua2l0ZWNvcnAudHJhbnNmZXJpZnkuYWNjb3VudC52MS5BY3RpdmF0ZUFjY291bnRSZXNwb25zZSIJirUYBQoDdXNlEnkKFVJlc2VuZEFjdGl2YXRpb25FbWFpbBI9LmtpdGVjb3JwLnRyYW5zZmVyaWZ5LmFjY291bnQudjEuUmVzZW5kQWN0aXZhdGlvbkVtYWlsUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eSIJirUYBQoDdXNlQkIKLWNvbS5raXRlY29ycC5jb250cmFjdHMudHJhbnNmZXJpZnkuYWNjb3VudC52MUIPQWN0aXZhdGlvblByb3RvUAFiBnByb3RvMw", [file_google_protobuf_empty, file_kitecorp_options_v1_options]);

/**
 * The link's token.
 *
 * @generated from message kitecorp.transferify.account.v1.ActivateAccountRequest
 */
export type ActivateAccountRequest = Message<"kitecorp.transferify.account.v1.ActivateAccountRequest"> & {
  /**
   * The token the activation link carries as its last path segment.
   *
   * @generated from field: string link_token = 1;
   */
  linkToken: string;
};

/**
 * Describes the message kitecorp.transferify.account.v1.ActivateAccountRequest.
 * Use `create(ActivateAccountRequestSchema)` to create a new message.
 */
export const ActivateAccountRequestSchema: GenMessage<ActivateAccountRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_account_v1_activation, 0);

/**
 * The activated account's profile snapshot, which the post-activation screen shows.
 *
 * @generated from message kitecorp.transferify.account.v1.ActivateAccountResponse
 */
export type ActivateAccountResponse = Message<"kitecorp.transferify.account.v1.ActivateAccountResponse"> & {
  /**
   * The legal name: the person's name, and the company when there is one.
   *
   * @generated from field: string full_name = 1;
   */
  fullName: string;

  /**
   * The account's proven address.
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * The profile's company, when it has one.
   *
   * @generated from field: optional string company = 3;
   */
  company?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.account.v1.ActivateAccountResponse.
 * Use `create(ActivateAccountResponseSchema)` to create a new message.
 */
export const ActivateAccountResponseSchema: GenMessage<ActivateAccountResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_account_v1_activation, 1);

/**
 * Asks for the activation mail again. It carries nothing.
 *
 * @generated from message kitecorp.transferify.account.v1.ResendActivationEmailRequest
 */
export type ResendActivationEmailRequest = Message<"kitecorp.transferify.account.v1.ResendActivationEmailRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.account.v1.ResendActivationEmailRequest.
 * Use `create(ResendActivationEmailRequestSchema)` to create a new message.
 */
export const ResendActivationEmailRequestSchema: GenMessage<ResendActivationEmailRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_account_v1_activation, 2);

/**
 * The activation of a paid account from the link its checkout returned to or its mail carried
 * (kitecorp/transferify-api-service#2933). Both methods are the signed-in account's own.
 *
 * @generated from service kitecorp.transferify.account.v1.ActivationService
 */
export const ActivationService: GenService<{
  /**
   * Activates the signed-in account from the link's token: the auth module proves the address the link was minted for,
   * and the api stores the storefront the call comes from as the account's mail context. A repeat answers the account
   * again. NOT_FOUND with the reason ACTIVATION_TOKEN_NOT_FOUND for a link the module refuses (expired, another
   * account's, or minted before the module did), UNAVAILABLE when the auth module could not answer, and INTERNAL while
   * the account's plan is not on yet (the checkout's webhook may be late), as the REST endpoint answered 500; the
   * browser offers a retry.
   *
   * @generated from rpc kitecorp.transferify.account.v1.ActivationService.ActivateAccount
   */
  activateAccount: {
    methodKind: "unary";
    input: typeof ActivateAccountRequestSchema;
    output: typeof ActivateAccountResponseSchema;
  },
  /**
   * Mails the account's activation link again, to its proven address only. An account whose address is unproven gets no
   * mail and the same empty success.
   *
   * @generated from rpc kitecorp.transferify.account.v1.ActivationService.ResendActivationEmail
   */
  resendActivationEmail: {
    methodKind: "unary";
    input: typeof ResendActivationEmailRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_account_v1_activation, 0);

